import { CheckboxField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import { useEventTypeContext } from 'features/event_type_provider';
const containerCss = "c1iq1gju";
const titleCss = "ttthdux";
const helperTextCss = "hj379no";
export const AdditionalSettings = ({
  isLocked
}) => {
  const {
    eventType
  } = useEventTypeContext();
  const {
    isGroup
  } = eventType;
  return <div className={containerCss} data-testid="additional-settings">
      <div className={titleCss}>
        <BodyText size="medium" weight="semibold">
          {I18n.t('publisher.event_type_editor_crud.meeting_details.additional_settings.title')}
        </BodyText>
      </div>

      {!isGroup && <CheckboxField name="guestsAllowed" label={I18n.t('publisher.event_type_editor_crud.meeting_details.additional_settings.allow_guests')} disabled={isLocked} data-testid="guests-allowed-checkbox" />}

      <div>
        <CheckboxField name="isPublic" label={I18n.t('publisher.event_type_editor_crud.meeting_details.additional_settings.show_on_landing_page')} disabled={isLocked} data-testid="show-on-landing-page-checkbox" />
        <div className={helperTextCss}>
          <BodyText color={colorTextSecondary} size="small">
            {I18n.t('publisher.event_type_editor_crud.meeting_details.additional_settings.show_on_landing_page_helper')}
          </BodyText>
        </div>
      </div>
    </div>;
};

require("./additional_settings.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./additional_settings.js");